import React, { useState } from 'react';
import { DModal } from '../../../../../dum';
import { ProductIcon } from '../../../../icons';
import { BulkOrderProductionForm } from './bulk-order-production-form';

interface IBulkOrderProductionDialog {
    open: boolean;
    setOpen: (open: boolean) => void;
}

export function SBulkUpsertOrderProductionDialog({
    open,
    setOpen,
}: IBulkOrderProductionDialog) {
    const [isModalClosing, setIsModalClosing] = useState(false);

    return (
        <DModal
            icon={<ProductIcon />}
            title={'Alta masiva — Órdenes de producción'}
            open={open}
            setOpen={setOpen}
            onExited={() => {
                setIsModalClosing(false);
            }}
        >
            <BulkOrderProductionForm
                disabled={isModalClosing}
                onSuccess={() => {
                    setOpen(false);
                    setIsModalClosing(true);
                }}
            />
        </DModal>
    );
}
